import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataEntity_Detail_03_Interface } from 'src/app/Interface/DataEntity/03/DataEntity_Detail_03_Interface';
import { DataEntity_Main_03_Interface } from 'src/app/Interface/DataEntity/03/DataEntity_Main_03_Interface';
import { DataEntity_Resolution_03_Interface } from 'src/app/Interface/DataEntity/03/DataEntity_Resolution_03_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataEntity03Service {

  constructor(private http: HttpClient) { }

  GetSingle(Token: String,
    id: Number,
    dataentity_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Dataentityno03/GetSingle?token=" + Token
      + "&id=" + id
      + "&dataentity_id=" + dataentity_id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  Submit(
    model_temp: DataEntity_Main_03_Interface,
    detail: Array<DataEntity_Detail_03_Interface>,
    resolution: Array<DataEntity_Resolution_03_Interface>,
    DataEntity_id: number,
    Calibration_Id: number,
    Filename: string,
    FolderName: string,
    Capability: string,
    DeviceSerial: string,
    DeviceCode: string,

    Manufacture_txt: String,
    Type_txt: String,
    Model_txt: String,
    LabAddress_txt: String,
    DELIVERY_TIME: Number,

    Fororaftegi_txt: String,
    working_temp_min_txt: String,
    working_temp_max_txt: String,

    Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var detail_list = []
    var mesured_list = []


    for (let item of detail) {
      detail_list.push({
        id: item.id,
        main_id: model_temp.id,
        indication: item.indication,
        reference: item.reference,

        uncertainty: item.uncertainty,
        converage: item.converage,
        value: item.value,

        before: item.before,
      })
    }



    var model={
      id:model_temp.id,
      filename: Filename,
      pdf_src: FolderName,
      delivery_time: DELIVERY_TIME,
      manufacture: Manufacture_txt,
      type: Type_txt,
      model: Model_txt,

      capability: Capability,


      fororaftegi: Fororaftegi_txt,
      working_temp_min: working_temp_min_txt,
      working_temp_max: working_temp_max_txt,

      unit_nomimal: model_temp.unit_nomimal,
      unit_reference: model_temp.unit_reference,
      unit_correction: model_temp.unit_correction,
      unit_correction_eqution: model_temp.unit_correction_eqution,
      unit_uncertainy: model_temp.unit_uncertainy,
      unit_working: model_temp.unit_working,
      unit_zfactor: model_temp.unit_zfactor,

      temperature_Air_before: model_temp.temperature_Air_before +'',
      temperature_Air_after: model_temp.temperature_Air_after+'',

      humidity_Air_before: model_temp.humidity_Air_before+'',
      humidity_Air_after: model_temp.humidity_Air_after+'',

      pressure_before: model_temp.pressure_before+'',
      pressure_after: model_temp.pressure_after+'',
    }

    var body = {
      Calibration_id: Calibration_Id,
      model: model,
      resolution : resolution,
      detail: detail_list,
      mesured: mesured_list,
      DeviceSerial: DeviceSerial,
      DeviceCode: DeviceCode,
      Token: Token,
      labAdderss: LabAddress_txt,
      dataentity_id: DataEntity_id,
    }



    return this.http.post(environment.BaseUrl + "Daro/Dataentityno03/Submit", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  uploadFile(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno03/upload?token="+Token,body).pipe(
      map(data=>{
        return data
      })
    )
  }

  uploadPdf(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno03/uploadPdf?token="+Token,body).pipe(
      map(data=>{
        return data
      })
    )
  }

}
